(function () {
  'use strict';

  /* @ngdoc object
   * @name eInvoices
   * @description
   *
   */
  angular
    .module('eInvoices', [
      'ui.router'
    ]);
}());
